<template>
  <div class="m-form-element">
    <div class="a-select bp3-select-group">
      <select
        :id="slug"
        class="bp3-select bp3-select-control"
        :data-cy="slug"
        :name="slug"
        @input="$emit(`update:${slug}`,$event.target.value)"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :selected="option.value === model"
          class="bp3-select-option"
        >
          {{ option.label }}
        </option>
      </select>

      <!-- Label -->
      <label
        class="bp3-select-label"
        :for="slug"
      >{{ label }}</label>
    </div>

    <!-- Message d'erreur -->
    <ErrorMessage :validation-status="v$[slug]" />
  </div>
</template>

<script>

import ErrorMessage from "./ErrorMessage";

export default {
  name: "InputText",
  components: {
    ErrorMessage
  },
  props: {
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>



</style>
